import { useContext, useMemo } from 'react';
import { ConfigContext } from 'contexts/ConfigContext';
import { getModelFeaturesFromFt, hasConversionFeatures } from 'utils/modelFeatures';

const useModelFeatures = (model) => {
    const { clientConfig } = useContext(ConfigContext);
    const featuresConfiguration = clientConfig.features;

    const modelFeatures = useMemo(() => {
        if (!model || !Array.isArray(model.FT)) {
            return [];
        }
        return getModelFeaturesFromFt(model.FT, featuresConfiguration, model.Gender);
    }, [model, featuresConfiguration]);

    const showConversionsButton = useMemo(() => hasConversionFeatures(modelFeatures), [modelFeatures]);

    return { modelFeatures, showConversionsButton };
};

export default useModelFeatures;
